// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-events{
    width: 100%;
  height: 127px;
  box-shadow: 0px 5px 22px rgba(0, 0, 0, 0.05);
    background-color: white;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 30px;
    margin-bottom: 32px;
    margin-top: 20px !important;
    cursor: pointer;
  }
  .card-events-web{
          display: flex;
          align-items: center;
          width: 100%;
  }
  .card-image{
      height: 80px;
      width: 80px;
  }
  .card-title{
      color: #68AD3F;
      font-size: 12px;
      font-weight: 500;
      }
      .card-event-name{
      color:#424242;
      font-size: 18px;
      }
      .card-date{
      color: #797979;
      font-size: 14px;
      }
      .card-mobile{
          display:none;
          width:100%;
      }
  @media only screen and (min-width: 0px) and (max-width: 480px) {
  
  .card-events {
      padding: 10px 0px 10px 0px;
      align-items: flex-start;
      flex-direction: column;
      height: 100%;
    }
    .card-events-web{
      display:none;
    }
    .card-mobile{
      display:block;
      width:100%;
    }
  
  .card-mobile-div {
      display: flex;
      align-items: center;
      padding: 0px 10px 0px 10px;
  }
  .card-image{
      height: 75px;
      width: 75px;
  }
  .card-title{
      font-size: 10px;
  }
  .card-event-name{
      font-size: 12px;
  }
  .card-date{
      font-size: 12px;
  }
  }
  @media only screen and (min-width: 481px) and (max-width: 768px) {
  .card-events {
          padding: 10px 0px 10px 0px;
          align-items: flex-start;
          flex-direction: column;
          height: 100%;
        } 
        .card-events-web{
          display:none;
        }
        .card-mobile{
          display: block;
          width:100%;
        }
  
      .card-mobile-div {
          display: flex;
          align-items: center;
          padding: 0px 10px 0px 10px;
      }
      .card-image{
          height: 75px;
          width: 75px;
      }
      .card-title{
          font-size: 13px;
      }
      .card-event-name{
          font-size: 15px;
      }
      .card-date{
          font-size: 12px;
      }
  }
  @media only screen and (min-width: 768px) and (max-width: 1024px) {
      .card-title{
          font-size: 12px;
      }
      .card-event-name{
          font-size: 16px;
      }
      .card-date{
          font-size: 13px;
      }
  }
  @media only screen and (min-width: 1900px) {
    .card-title{
        font-size: 14px;
        }
        .card-event-name{
        font-size: 20px;
        }
        .card-date{
        font-size: 16px;
        }
  }
`, "",{"version":3,"sources":["webpack://./src/Components/CardOrg/Card.css"],"names":[],"mappings":"AAAA;IACI,WAAW;EACb,aAAa;EACb,4CAA4C;IAC1C,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,eAAe;EACjB;EACA;UACQ,aAAa;UACb,mBAAmB;UACnB,WAAW;EACnB;EACA;MACI,YAAY;MACZ,WAAW;EACf;EACA;MACI,cAAc;MACd,eAAe;MACf,gBAAgB;MAChB;MACA;MACA,aAAa;MACb,eAAe;MACf;MACA;MACA,cAAc;MACd,eAAe;MACf;MACA;UACI,YAAY;UACZ,UAAU;MACd;EACJ;;EAEA;MACI,0BAA0B;MAC1B,uBAAuB;MACvB,sBAAsB;MACtB,YAAY;IACd;IACA;MACE,YAAY;IACd;IACA;MACE,aAAa;MACb,UAAU;IACZ;;EAEF;MACI,aAAa;MACb,mBAAmB;MACnB,0BAA0B;EAC9B;EACA;MACI,YAAY;MACZ,WAAW;EACf;EACA;MACI,eAAe;EACnB;EACA;MACI,eAAe;EACnB;EACA;MACI,eAAe;EACnB;EACA;EACA;EACA;UACQ,0BAA0B;UAC1B,uBAAuB;UACvB,sBAAsB;UACtB,YAAY;QACd;QACA;UACE,YAAY;QACd;QACA;UACE,cAAc;UACd,UAAU;QACZ;;MAEF;UACI,aAAa;UACb,mBAAmB;UACnB,0BAA0B;MAC9B;MACA;UACI,YAAY;UACZ,WAAW;MACf;MACA;UACI,eAAe;MACnB;MACA;UACI,eAAe;MACnB;MACA;UACI,eAAe;MACnB;EACJ;EACA;MACI;UACI,eAAe;MACnB;MACA;UACI,eAAe;MACnB;MACA;UACI,eAAe;MACnB;EACJ;EACA;IACE;QACI,eAAe;QACf;QACA;QACA,eAAe;QACf;QACA;QACA,eAAe;QACf;EACN","sourcesContent":[".card-events{\n    width: 100%;\n  height: 127px;\n  box-shadow: 0px 5px 22px rgba(0, 0, 0, 0.05);\n    background-color: white;\n    border-radius: 4px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 30px;\n    margin-bottom: 32px;\n    margin-top: 20px !important;\n    cursor: pointer;\n  }\n  .card-events-web{\n          display: flex;\n          align-items: center;\n          width: 100%;\n  }\n  .card-image{\n      height: 80px;\n      width: 80px;\n  }\n  .card-title{\n      color: #68AD3F;\n      font-size: 12px;\n      font-weight: 500;\n      }\n      .card-event-name{\n      color:#424242;\n      font-size: 18px;\n      }\n      .card-date{\n      color: #797979;\n      font-size: 14px;\n      }\n      .card-mobile{\n          display:none;\n          width:100%;\n      }\n  @media only screen and (min-width: 0px) and (max-width: 480px) {\n  \n  .card-events {\n      padding: 10px 0px 10px 0px;\n      align-items: flex-start;\n      flex-direction: column;\n      height: 100%;\n    }\n    .card-events-web{\n      display:none;\n    }\n    .card-mobile{\n      display:block;\n      width:100%;\n    }\n  \n  .card-mobile-div {\n      display: flex;\n      align-items: center;\n      padding: 0px 10px 0px 10px;\n  }\n  .card-image{\n      height: 75px;\n      width: 75px;\n  }\n  .card-title{\n      font-size: 10px;\n  }\n  .card-event-name{\n      font-size: 12px;\n  }\n  .card-date{\n      font-size: 12px;\n  }\n  }\n  @media only screen and (min-width: 481px) and (max-width: 768px) {\n  .card-events {\n          padding: 10px 0px 10px 0px;\n          align-items: flex-start;\n          flex-direction: column;\n          height: 100%;\n        } \n        .card-events-web{\n          display:none;\n        }\n        .card-mobile{\n          display: block;\n          width:100%;\n        }\n  \n      .card-mobile-div {\n          display: flex;\n          align-items: center;\n          padding: 0px 10px 0px 10px;\n      }\n      .card-image{\n          height: 75px;\n          width: 75px;\n      }\n      .card-title{\n          font-size: 13px;\n      }\n      .card-event-name{\n          font-size: 15px;\n      }\n      .card-date{\n          font-size: 12px;\n      }\n  }\n  @media only screen and (min-width: 768px) and (max-width: 1024px) {\n      .card-title{\n          font-size: 12px;\n      }\n      .card-event-name{\n          font-size: 16px;\n      }\n      .card-date{\n          font-size: 13px;\n      }\n  }\n  @media only screen and (min-width: 1900px) {\n    .card-title{\n        font-size: 14px;\n        }\n        .card-event-name{\n        font-size: 20px;\n        }\n        .card-date{\n        font-size: 16px;\n        }\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
